import { ComponentProps } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

import { Tooltip } from '@cast/design-system';

import { HeaderButton } from './HeaderButton';

const useIsWideScreen = () => {
  const { breakpoints } = useTheme();
  return useMediaQuery(breakpoints.up('lg'));
};

type HeaderButtonWithTooltipProps = Omit<
  ComponentProps<typeof HeaderButton>,
  'children'
> & {
  label: string;
};

export const HeaderButtonWithTooltip = ({
  label,
  testId,
  ...buttonProps
}: HeaderButtonWithTooltipProps) => {
  const isWideScreen = useIsWideScreen();

  return (
    <Tooltip title={label} wrapIf={!isWideScreen} testId={`${testId}-tooltip`}>
      <HeaderButton {...buttonProps} testId={testId}>
        {isWideScreen ? label : null}
      </HeaderButton>
    </Tooltip>
  );
};
